import React, { FC, useEffect } from 'react'
import { useSpBreakPoint } from '../../hooks/use_sp_breakpoint'
import Head2 from '../../components/heads/head2'
import PagiNationCursor from '../../components/pagination/pagination_cursor'
import SearchTab from './components/tab/search_tab'
import useUserSearchForm from './hooks/use_user_search_form'
import UserCard from '../../components/card/user_card'
import UserSearchForm from './components/form/user_search_form'
import { useToggle } from 'react-use'
import CommonTemplate from '../../components/templates/common_template'
import { useSearchParams } from 'react-router-dom'
import LoadingSpinner from '../../components/loading/loading_spinner'

// TODO 他検索ページといい感じに共通化したい
const UserSearchPage: FC = () => {
  const PAGE_SIZE = 20

  const isSp = useSpBreakPoint()
  const [users, size, currentCursor, isLoading, isSearched, userSearchHandler] =
    useUserSearchForm({
      getLimit: PAGE_SIZE,
    })
  const [formShow, toggle] = useToggle(true)
  const [queryParam] = useSearchParams()

  const IndexSectionRef = React.createRef<HTMLDivElement>()
  const scrollToIndexSection = () => {
    if (IndexSectionRef.current) {
      const elementPosition =
        IndexSectionRef.current.getBoundingClientRect().top + window.scrollY
      const offsetPosition = elementPosition - 100
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    }
  }

  useEffect(() => {
    if (users.length === 0) {
      toggle(true)
    }
  }, [users])

  useEffect(() => {
    const searchParams = {
      keyword: '',
      sdgsCategory: '',
      occupation: '',
    }
    let isQuery = false
    const querySearchKeyMap = [
      {
        queryParamKey: 'keyword',
        searchParamKey: 'keyword',
      },
      {
        queryParamKey: 'sdgs-category',
        searchParamKey: 'sdgsCategory',
      },
      {
        queryParamKey: 'occupation',
        searchParamKey: 'occupation',
      },
    ] as const
    querySearchKeyMap.forEach((item) => {
      if (queryParam.has(item.queryParamKey)) {
        const val = queryParam.get(item.queryParamKey) as string
        userSearchHandler.setValue(item.searchParamKey, val)
        searchParams[item.searchParamKey] = val
        isQuery = true
      }
    })

    if (isQuery) {
      userSearchHandler.submit(searchParams)
    }
  }, [])

  const searchResultElem = (
    <div>
      <div className="mb-4 px-4">
        <Head2
          title="ユーザー一覧"
          subTitle={
            users.length > 0
              ? `全件${String(size)}中 ${currentCursor + 1}~${
                  currentCursor + users.length
                }件`
              : ''
          }
        />
      </div>
      <div className="flex sm:justify-start justify-center flex-wrap">
        {users.length > 0 ? (
          users.map((item, index) => {
            return (
              <div
                key={`user-${String(index)}`}
                className={`py-3 md:p-3 lg:p-4 w-1/2 md:w-4/12 lg:w-3/12 ${
                  index % 2 === 0
                    ? 'pl-2 pr-1 xs:pl-4 xs:pr-2'
                    : 'pl-1 pr-2 xs:pl-2 xs:pr-4'
                }`}
              >
                <UserCard
                  user={item}
                  imgSize="sm:w-[160px] sm:h-[160px] xs:w-[120px] xs:h-[120px] w-[100px] h-[100px]"
                  className="!w-full"
                />
              </div>
            )
          })
        ) : (
          <div className="w-full">
            <p className="text-center text-main-lightGray">
              検索結果がありません
            </p>
          </div>
        )}
      </div>
    </div>
  )

  const paginationCursor =
    users.length > 0 ? (
      <PagiNationCursor
        pageCount={Math.ceil(size / PAGE_SIZE)}
        numRange={3}
        activePageNum={Math.floor(currentCursor / PAGE_SIZE) + 1}
        next={() => {
          scrollToIndexSection()
          userSearchHandler.submit(
            userSearchHandler.getValues(),
            currentCursor + PAGE_SIZE
          )
        }}
        prev={() => {
          scrollToIndexSection()
          userSearchHandler.submit(
            userSearchHandler.getValues(),
            currentCursor - PAGE_SIZE
          )
        }}
        jump={(pageNum: number) => {
          scrollToIndexSection()
          userSearchHandler.submit(
            userSearchHandler.getValues(),
            (pageNum - 1) * PAGE_SIZE
          )
        }}
      />
    ) : null

  const searchTab = (
    <SearchTab
      isSp={isSp}
      activeIndex={2}
      isFormShow={formShow}
      toggleContent={toggle}
      form={
        <UserSearchForm
          keywordOptions={userSearchHandler.register('keyword')}
          sdgsCategoryOptions={userSearchHandler.register('sdgsCategory')}
          occupationOptions={userSearchHandler.register('occupation')}
          onSubmit={userSearchHandler.handleSubmit((data) =>
            userSearchHandler.submit(data)
          )}
          toggleForm={toggle}
        />
      }
    />
  )

  const content = (
    <CommonTemplate isPadding={!isSp} isSp={isSp} additonalTopNode>
      <div>
        <div className="mt-4 mb-8">{searchTab}</div>
        {isLoading && <LoadingSpinner className="mx-auto" />}

        {isSearched && !isLoading && (
          <>
            <div ref={IndexSectionRef} />
            <div className="mb-8">{searchResultElem}</div>
            <div className="pb-8">{paginationCursor}</div>
          </>
        )}

        {!isSearched && (
          <div className="w-full">
            <p className="text-center text-main-lightGray">
              検索条件を入力してください
            </p>
          </div>
        )}
      </div>
    </CommonTemplate>
  )
  return content
}

export default UserSearchPage
